import { z } from 'zod';
import { BaseRuleSchema } from '../types/compliance.js';

export const GetBaseRules = {
  responseSchema: z.object({
    rules: z.array(BaseRuleSchema),
  }),
};

export const GetBaseCategories = {
  responseSchema: z.object({
    categories: z.array(z.string()),
  }),
};
